import { Divider, Grid } from '@mui/material'
import { AppAutoComplete, AppBox, AppButton, AppIcon, AppTypography } from 'components'
import { useCrmCompanyLinkedContacts } from 'hooks'
import { useEffect, useState } from 'react'
import { Form, useForm } from 'react-hook-form'
import { CrmcontactLinkedCompanyPayload, ShowAlert } from 'sdk'
import { CrmCompanyLinkedContactsTable } from './listing/CrmCompanyLinkedContactsTable'

interface Props {
  companyId: string
}
export const CrmCompanyLinkedContacts = ({ companyId }: Props) => {
  const [isAddClicked, setIsAddClicked] = useState<boolean>(false)
  const { control, reset } = useForm<CrmcontactLinkedCompanyPayload>({ defaultValues: { CompanyId: companyId } })
  const {
    linkCompany,
    UnlinkCompany,
    getCompanyLinkedContacts,
    getCompanyUnLinkedContacts,
    isUnlinking,
    isAddingLinkedCompany,
    companyUnLinkedContacts,
    isGettingCompanyUnLinkedContacts,
    companyLinkedContacts,
  } = useCrmCompanyLinkedContacts({
    companyId: companyId,
  })

  useEffect(() => {
    getCompanyLinkedContacts()
    getCompanyUnLinkedContacts()
  }, [])

  const handleUnlinkClick = (contactId: string) => {
    ShowAlert(
      'question',
      `You are about to break the link between this contact and this company. You can add them back anytime while this contact remains in your CRM. <br /><br />Do you wish to continue?`
    ).then((result) => {
      if (result.isConfirmed) {
        UnlinkCompany(contactId)
        reset({ CompanyId: companyId })
      }
    })
  }
  return (
    <AppBox
      border={1}
      paddingX={4}
      paddingY={2}
      backgroundColor="white"
      borderColor={'grey.200'}
      borderRadius={6}
      id="Companies"
    >
      <AppBox display={'flex'} justifyContent={'space-between'} alignItems={'center'} paddingBottom={2}>
        <AppTypography fontWeight={700} fontSize={16}>
          Contacts
        </AppTypography>
        {!isAddClicked ? (
          <AppButton variant="contained" prefixIcon="tabler:plus" size="large" onClick={() => setIsAddClicked(true)}>
            Add
          </AppButton>
        ) : (
          <Form control={control} onSubmit={({ data }) => linkCompany(data)}>
            <Grid container spacing={2} alignItems={'center'} minWidth={450}>
              <Grid item xs={8}>
                <AppAutoComplete
                  options={
                    companyUnLinkedContacts?.map((x) => {
                      return { value: x.Id!, label: x.ContactEmail! }
                    }) ?? []
                  }
                  fullWidth
                  placeholder="Search Contacts"
                  control={control}
                  name={'ContactId'}
                  required
                  isLoading={isGettingCompanyUnLinkedContacts}
                />
              </Grid>
              <Grid item xs={4}>
                <AppBox display={'flex'} alignItems={'center'} gap={1}>
                  <AppButton
                    isLoading={isAddingLinkedCompany}
                    variant="contained"
                    prefixIcon="tabler:plus"
                    size="large"
                    type="submit"
                  >
                    Add
                  </AppButton>
                  <AppBox>
                    <AppIcon
                      icon={'mdi:cross-circle'}
                      color="#0067D0"
                      size="extra-large"
                      onClick={() => setIsAddClicked(false)}
                    />
                  </AppBox>
                </AppBox>
              </Grid>
            </Grid>
          </Form>
        )}
      </AppBox>

      <Divider />
      <AppBox paddingY={4}>
        <CrmCompanyLinkedContactsTable
          onRemoveClick={handleUnlinkClick}
          data={companyLinkedContacts ?? []}
          isLoading={isGettingCompanyUnLinkedContacts || isUnlinking}
        />
      </AppBox>
    </AppBox>
  )
}
